'use client';

import customFetch from '@/api/fetch';
import { useAuthV2 } from '@/hooks/useAuthV2';
import { createPreferredLocaleSync } from '@/utils/preferredLocale';
import { useParams } from 'next/navigation';
import { useEffect } from 'react';

const sessionStore = () => {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  } catch {
    return null;
  }
};

const syncPreferredLocale = createPreferredLocaleSync(
  (locale) =>
    customFetch('/users/me/preferred-locale', {
      method: 'PUT',
      body: JSON.stringify({ locale }),
    }),
  sessionStore()
);

/**
 * Idioma em que o usuário recebe os e-mails. Um efeito só cobre login, restauração de sessão e
 * troca de idioma, já que todos passam pelo estado de auth ou pelo segmento [lng] da rota.
 */
export function PreferredLocaleSync() {
  const { lng } = useParams() as { lng?: string };
  const { user, userData, sessionStatus } = useAuthV2();
  const userId = (userData ?? user)?.id;

  useEffect(() => {
    if (sessionStatus !== 'authenticated' || !userId) return;
    void syncPreferredLocale(userId, lng);
  }, [sessionStatus, userId, lng]);

  return null;
}
